// Modelos de Calypso en la Sala (Máquina y Cuentas y lupa): su nombre para Pau y su color en las gráficas. Puro.
import { t, type TKey } from '../../../i18n';

const CONOCIDOS = ['deepseek-v4-pro', 'deepseek-v4-pro-ckpt-abril', 'deepseek-v4-flash'];

/** Trazo de la línea, fondo de la leyenda y relleno del punto marcado al pasar el ratón: el mismo color. */
export interface ColorModelo {
  trazo: string;
  fondo: string;
  punto: string;
}

/** Colores fijos para los modelos conocidos (así un modelo no cambia de color de un día a otro). */
const COLOR_CONOCIDO: Record<string, ColorModelo> = {
  'deepseek-v4-pro': { trazo: 'stroke-oficina-te-necesita', fondo: 'bg-oficina-te-necesita', punto: 'fill-oficina-te-necesita' },
  'deepseek-v4-pro-ckpt-abril': { trazo: 'stroke-oficina-error', fondo: 'bg-oficina-error', punto: 'fill-oficina-error' },
  'deepseek-v4-flash': { trazo: 'stroke-oficina-trabajando', fondo: 'bg-oficina-trabajando', punto: 'fill-oficina-trabajando' },
};
/** Paleta de los nuevos, por orden de volumen. 10-10 (Pau): antes empezaba por «marca», el mismo oro que «Modelo normal»
 *  (y seguía con «enlace», otro amarillo): un modelo nuevo no se distinguía. Ninguno de estos repite los de arriba. */
const PALETA = [
  { trazo: 'stroke-oficina-cerebro-azul', fondo: 'bg-oficina-cerebro-azul', punto: 'fill-oficina-cerebro-azul' },
  { trazo: 'stroke-oficina-cerrando', fondo: 'bg-oficina-cerrando', punto: 'fill-oficina-cerrando' },
  { trazo: 'stroke-oficina-bloqueado', fondo: 'bg-oficina-bloqueado', punto: 'fill-oficina-bloqueado' },
  { trazo: 'stroke-oficina-texto2', fondo: 'bg-oficina-texto2', punto: 'fill-oficina-texto2' },
];

/** Sin el proveedor delante («deepseek/deepseek-v4-pro» es «deepseek-v4-pro»). */
const sinProveedor = (m: string) => m.replace(/^[^/]+\//, '');

export function colorModelo(m: string, orden: string[]): ColorModelo {
  const conocido = COLOR_CONOCIDO[sinProveedor(m)];
  if (conocido) return conocido;
  const nuevos = orden.filter((x) => !COLOR_CONOCIDO[sinProveedor(x)]);
  return PALETA[Math.max(0, nuevos.indexOf(m)) % PALETA.length]!;
}

const SIGLAS: Record<string, string> = { gpt: 'GPT' };

/** Nombre para Pau. Un modelo nuevo sale con un nombre legible sacado de su identificador («anthropic/claude-haiku-4.5»
 *  → «Haiku 4.5»), nunca escondido como «otros»; el identificador completo queda en el `title` de quien lo pinte. */
export function nombreModelo(m: string): string {
  const id = sinProveedor(m);
  if (CONOCIDOS.includes(id)) return t(`salaControl.rincones.maquina.modelos.${id}` as TKey);
  return id
    .replace(/^claude-/, '')
    .split('-')
    .filter(Boolean)
    .map((p) => SIGLAS[p.toLowerCase()] ?? p.charAt(0).toUpperCase() + p.slice(1))
    .join(' ');
}

/** Familias con nombre propio para Pau en la vista por modelo del Pulso (backend sala/modelos.ts familiaModelo). */
const FAMILIAS = ['deepseek-v4-pro', 'deepseek-v41-flash', 'deepseek-v4-flash'];

/** Nombre para Pau de una familia de cerebro («DeepSeek Pro»); una familia nueva sale con su nombre legible. */
export function nombreFamilia(f: string): string {
  return FAMILIAS.includes(f) ? t(`salaControl.modelos.familias.${f}` as TKey) : nombreModelo(f);
}
